import React from 'react'
import MyListBlock from '../../../../../UI/list/MyListBlock'
import { useState } from 'react'
import { useEffect } from 'react'
import { Link } from 'react-router-dom'
import { unitMeasureShortText } from '../../../../../../helpers/unitMeasure/UnitMeasureHelper'
import ChangeNameInBillButton from '../../../forms/changeNameInBill/ChangeNameInBillButton'
import ChangeContractButton from '../../../forms/changeContract/ChangeContractButton'
import ChangeExpenseTypeButton from '../../../forms/changeExpenseType/ChangeExpenseTypeButton'
import ChangeSkuButton from '../../../forms/changeSku/ChangeSkuButton'
import ChangePriceBillItemButton from '../../../forms/changePrice/ChangePriceBillItemButton'
import AgreeNachButton from '../../../forms/agreeNach/AgreeNachButton'
import AgreeEconomistButton from '../../../forms/agreeEconomist/AgreeEconomistButton'
import AgreeHeaderButton from '../../../forms/agreeHeader/AgreeHeaderButton'
import DeleteBillItemButton from '../../../forms/deleteItem/DeleteBillItemButton'
import AgreeDeputyDirectorSupplyButton from '../../../forms/agreeDeputyDirectorSupply/AgreeDeputyDirectorSupplyButton'
// import UnitMeasureShortText from '../../../../../unitMeasure/UnitMeasureShortText'
import { useSelector } from 'react-redux'

const SupplyBillItemOne = ({ supplyBillItem, index }) => {

    const unitMeasures = useSelector(state => state.settings.unitMeasures)
    const unitMeasure = unitMeasures && unitMeasures[supplyBillItem.unitMeasure] ? unitMeasures[supplyBillItem.unitMeasure].name : '?'

    const [list, setList] = useState([])
    const [listSecond, setListSecond] = useState([])

    useEffect(() => {
        setListItems()
        setListSecondItems()
    }, [supplyBillItem])

    const setListItems = () => {
        const listTemp = []

        listTemp.push({
            // name: '№ (ID)',
            // value: `${index + 1} (${supplyBillItem.id})`
            name: 'ID',
            value: supplyBillItem.id
        })
        listTemp.push({
            name: 'Заявка №',
            value: 
				supplyBillItem.supplyOrder ? 
                    <Link to={`/supply/orders/${supplyBillItem.supplyOrder.id}`}>
                        {supplyBillItem.supplyOrder.id}
                    </Link>
                : ''
			
        })
        listTemp.push({
            name: 'Підрозділ',
            value: 
                // supplyBillItem.supplyOrder
                supplyBillItem.supplyOrder.departmentType ? supplyBillItem.supplyOrder.departmentType.name + ' - ' + supplyBillItem.supplyOrder.department.name : '-'
        })
        listTemp.push({
            name: 'Назва',
            value: supplyBillItem.name
        })
        listTemp.push({
            name: 'Назва в рахунку',
            value: 
                <ChangeNameInBillButton
                    supplyBillItem={supplyBillItem}
                />
        })
        listTemp.push({
            name: 'Контракт / проект',
            value: 
                <ChangeContractButton
                    supplyBillItem={supplyBillItem}
                />
        })
        listTemp.push({
            name: 'Тип закупівлі',
            value: 
                <ChangeExpenseTypeButton
                    supplyBillItem={supplyBillItem}
                />
        })
        listTemp.push({
            name: 'Артикул',
            value: 
                <ChangeSkuButton
                    supplyBillItem={supplyBillItem}
                />
        })
        listTemp.push({
            name: 'Кількість',
            // value: supplyBillItem.count + ' ' + unitMeasureShortText[supplyBillItem.unitMeasure]
            // value: supplyBillItem.count + ' ' + (unitMeasures[supplyBillItem.unitMeasure] ? unitMeasures[supplyBillItem.unitMeasure].name : '?')
            value: supplyBillItem.count + ' ' + unitMeasure
        })

        setList(listTemp)
    }

    const setListSecondItems = () => {
        const listTemp = []

        listTemp.push({
            name: 'Вартість',
            value: 
                <ChangePriceBillItemButton
                    supplyBillItem={supplyBillItem}
                />
        })
        listTemp.push({
            name: 'Погодження',
            value: 
                <div className='supplyAgrees'>
                    <AgreeNachButton
                        supplyBillItem={supplyBillItem}
                    />
                    <AgreeEconomistButton 
                        supplyBillItem={supplyBillItem}
                    />
                    <AgreeDeputyDirectorSupplyButton
                        supplyBillItem={supplyBillItem}
                    />
                    <AgreeHeaderButton
                        supplyBillItem={supplyBillItem}
                    />
                </div>
        })
        listTemp.push({
            name: 'Дії з позицією',
            value: 
                <DeleteBillItemButton
                    supplyBillItem={supplyBillItem}
                />
        })

        setListSecond(listTemp)
    }

  return (
    <div className='supplyBillItem__one'>
        {/* <div> */}
            <MyListBlock 
                className={'supplyOrderView__topBlock myListBlock__wrap'}
                text={`Позиція №${index + 1}`}
                list={list} 
            />
        {/* </div> */}
        <MyListBlock 
            className={'supplyOrderView__topBlock w250'}
            // text={`Позиція №${index + 1}`}
            list={listSecond} 
        />
    </div>
  )
}

export default SupplyBillItemOne